import Vue from "vue";
import Vuex from "vuex";
import { gethxFloor, gethxColumn } from "@/utils/api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    data: null,
  },
  mutations: {
    // 存储数据
    setData(state, payload) {
      // console.log(state, 222, payload);
      state.data = payload;
    },
  },
  getters: {
    getData(state) {
      console.log(state.data);
      return state.data;
    },
  },
  actions: {
    // 异步操作
    async fetchData({ commit }) {
      let res = await gethxColumn();
      // console.log(res.data.data[0].id, 2222);
      commit("setData", res.data.data[0].id);
    },
  },
});
